export const SLA_MESSAGE_DATE_FORMAT = 'DD [de] MMMM';
